import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { ProductType } from '../../Billing/billing-types';
// @ts-ignore
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
// @ts-ignore
import CapabilityReason from '@/components/dialogs/CouldntDowngradeBillingPlanDialog/CapabilityReason.vue';
// @ts-ignore
import WorkflowCapabilityReason from '@/components/dialogs/CouldntDowngradeBillingPlanDialog/WorkflowCapabilityReason.vue';
// @ts-ignore
import { CAPABILITIES_MAP } from '@/components/dialogs/CouldntDowngradeBillingPlanDialog/capabilities-consts';
import IntercomService from '@/utils/IntercomService';
interface ProductDowngradeFailure {
	error: string;
	reasons: string[];
	is_downgrade_failure: boolean;
	invalid_workflows: { [workflowId: string]: string[] };
}
interface ProductMessage {
	msg: string;
}
interface Message {
	[ProductType.Credits]: ProductDowngradeFailure | ProductMessage;
	[ProductType.Automation]: ProductDowngradeFailure | ProductMessage;
	[ProductType.TeamFeatures]: ProductDowngradeFailure | ProductMessage;
	[ProductType.CustomerFeatures]: ProductDowngradeFailure | ProductMessage;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CouldntDowngradeBillingPlanDialog',
  props: {
    message: null,
    dialogPromiseHandlers: null
  },
  setup(__props: any) {

const props = __props as {
	message: Message;
	dialogPromiseHandlers: { resolve: () => void; reject: () => void };
}


console.log(props.message);
const downgradeFailedProducts = computed(() =>
	// @ts-ignore
	Object.keys(props.message).filter((productType) => props.message[productType].is_downgrade_failure)
);
const contactUs = () => IntercomService.showNewMessage(`I need help understanding why couldn't I downgrade my plans`);

const getReadableProductType = (productType: ProductType) => {
	switch (productType) {
		case ProductType.Credits:
			return 'Credits';
		case ProductType.Automation:
			return 'Automation';
		case ProductType.TeamFeatures:
			return 'Team features';
		case ProductType.CustomerFeatures:
			return 'Customer features';
		default:
			return '';
	}
};
const close = () => {
	props.dialogPromiseHandlers.resolve();
	AppDialogManagerService.closeCurrentDialog();
};

return { __sfc: true,props, downgradeFailedProducts, contactUs, getReadableProductType, close, AppDialog, CapabilityReason, WorkflowCapabilityReason, CAPABILITIES_MAP }
}

})